import axios from 'axios';
import { awsInfo } from './aws-info'
import { CognitoUserAccessor } from "./cognito-login"

// 共通処理
const instance = axios.create({
  baseURL: awsInfo.webapiUrl,
  timeout: 30000,
  cors: true,
})

// クラス化
class WebAPI {

  apiRequest(authToken, body) {
    return instance.request({
      method: 'POST',
      url: '/',
      headers: {
        Authorization: authToken
      },
      data: body
    });
  }

  async addBirthCalf(barn_id, date_time, birth_id) {
    try {
      const currentUser = await CognitoUserAccessor.getCurrentUser();
      const authToken = currentUser.idToken.jwtToken;
      const body = {
        command: "add_birth_calf",
        barn_id: barn_id,
        date_time: date_time,
        birth_id: birth_id
      };
      let response = await this.apiRequest(authToken, body);
      response['authToken'] = authToken;
      return response;
    }
    catch (e) {
      const response = {"status": 400, "message": e};
      return response;
    }
  }

  async getCowNumberNames(farmer_id) {
    try {
      const currentUser = await CognitoUserAccessor.getCurrentUser();
      const authToken = currentUser.idToken.jwtToken;
      const body = {
        command: "get_cow_number_names",
        farmer_id: farmer_id
      };
      let response = await this.apiRequest(authToken, body);
      response['authToken'] = authToken;
      return response;
    }
    catch (e) {
      const response = {"status": 400, "message": e};
      return response;
    }
  }

  async getCowReportsInBarn2(barn_id, report_dates) {
    try {
      const currentUser = await CognitoUserAccessor.getCurrentUser();
      const authToken = currentUser.idToken.jwtToken;
      const body = {
        command: "get_cow_reports_in_barn2",
        barn_id: barn_id,
        report_dates: report_dates
      };
      let response = await this.apiRequest(authToken, body);
      response['authToken'] = authToken;
      return response;
    }
    catch (e) {
      const response = {"status": 400, "message": e};
      return response;
    }
  }

  async getCowTrackReportDatesInBarn2(barn_id, cow_track_id) {
    try {
      const currentUser = await CognitoUserAccessor.getCurrentUser();
      const authToken = currentUser.idToken.jwtToken;
      const body = {
        command: "get_cow_track_report_dates_in_barn2",
        barn_id: barn_id,
        cow_track_id: cow_track_id
      };
      let response = await this.apiRequest(authToken, body);
      response['authToken'] = authToken;
      return response;
    }
    catch (e) {
      const response = {"status": 400, "message": e};
      return response;
    }
  }

  async getCowReportDatesInBarn2(barn_id) {
    try {
      const currentUser = await CognitoUserAccessor.getCurrentUser();
      const authToken = currentUser.idToken.jwtToken;
      const body = {
        command: "get_cow_report_dates_in_barn2",
        barn_id: barn_id
      };
      let response = await this.apiRequest(authToken, body);
      response['authToken'] = authToken;
      return response;
    }
    catch (e) {
      const response = {"status": 400, "message": e};
      return response;
    }
  }

  async controlCamera(camera_id, get_settings, restart, continuous_af, af_request, zoom_level) {
    try {
      const currentUser = await CognitoUserAccessor.getCurrentUser();
      const authToken = currentUser.idToken.jwtToken;
      const body = {
        command: "control_camera",
        camera_id: camera_id,
        get_settings: get_settings,
        restart: restart,
        continuous_af: continuous_af,
        af_request: af_request,
        zoom_level: zoom_level
      };
      if (get_settings === "") { delete body.get_settings;}
      if (restart === "") { delete body.restart;}
      if (continuous_af === "") { delete body.continuous_af;}
      if (af_request === "") { delete body.af_request;}
      if (zoom_level === "") { delete body.zoom_level;}
      let response = await this.apiRequest(authToken, body);
      response['authToken'] = authToken;
      return response;
    } catch (e) {
        const response = {"status": 400, "message": e};
        return response;
    }
  }

  async getFarmerDls(farmer_id) {
    try {
        const currentUser = await CognitoUserAccessor.getCurrentUser();
        const authToken = currentUser.idToken.jwtToken;
        const body = {
            command: "get_farmer_dls",
            farmer_id: farmer_id
        };
        let response = await this.apiRequest(authToken, body);
        response['authToken'] = authToken;
        return response;
    }
    catch (e) {
        const response = {"status": 400, "message": e};
        return response;
    }
  }

  async getCameras(barn_id) {
    try {
        const currentUser = await CognitoUserAccessor.getCurrentUser();
        const authToken = currentUser.idToken.jwtToken;
        const body = {
            command: "get_cameras",
            barn_id: barn_id
        };
        let response = await this.apiRequest(authToken, body);
        response['authToken'] = authToken;
        return response;
    }
    catch (e) {
        const response = {"status": 400, "message": e};
        return response;
    }
  }

  async controlNvr(nvr_id, system_restart, software_restart, camera_id, version_request, log_request, update_request) {
    try {
        const currentUser = await CognitoUserAccessor.getCurrentUser();
        const authToken = currentUser.idToken.jwtToken;
        const body = {
            command: "control_nvr",
            nvr_id: nvr_id,
            system_restart: system_restart,
            software_restart: software_restart,
            camera_restart: camera_id,
            version_request: version_request,
            log_request: log_request,
            update_request: update_request
        };
        if (system_restart==="") { delete body.system_restart;}
        if (software_restart==="") { delete body.software_restart;}
        if (camera_id === "") { delete body.camera_restart;}
        if (version_request === "") { delete body.version_request;}
        if (log_request === "") { delete body.log_request;}
        if (update_request === "") { delete body.update_request;}
        let response = await this.apiRequest(authToken, body);
        response['authToken'] = authToken;
        return response;
    }
    catch (e) {
        const response = {"status": 400, "message": e};
        return response;
    }
  }

  async controlDl(dl_id, system_restart, software_restart, camera_id, version_request, log_request, update_request) {
    try {
        const currentUser = await CognitoUserAccessor.getCurrentUser();
        const authToken = currentUser.idToken.jwtToken;
        const body = {
            command: "control_dl",
            dl_id: dl_id,
            system_restart: system_restart,
            software_restart: software_restart,
            camera_restart: camera_id,
            version_request: version_request,
            log_request: log_request,
            update_request: update_request
        };
        if (system_restart==="") { delete body.system_restart;}
        if (software_restart==="") { delete body.software_restart;}
        if (camera_id === "") { delete body.camera_restart;}
        if (version_request === "") { delete body.version_request;}
        if (log_request === "") { delete body.log_request;}
        if (update_request === "") { delete body.update_request;}
        let response = await this.apiRequest(authToken, body);
        response['authToken'] = authToken;
        return response;
    }
    catch (e) {
        const response = {"status": 400, "message": e};
        return response;
    }
  }

  async getCommonKey(pubKey) {
    try {
      const currentUser = await CognitoUserAccessor.getCurrentUser();
      const authToken = currentUser.idToken.jwtToken;
      const body = {
        command: "get_common_key",
        public_key: pubKey
      };
      let response = await this.apiRequest(authToken, body);
      response['authToken'] = authToken;
      return response;
    } catch (e) {
      const response = {"status": 400, "message": e};
      return response;
    }
  }

  async updateFarmerFeedingTimes(farmer_id, add_time, del_time) {
    try {
      const currentUser = await CognitoUserAccessor.getCurrentUser();
      const authToken = currentUser.idToken.jwtToken;
      const body = {
        command: "update_farmer_feeding_times",
        farmer_id: farmer_id,
        add: [add_time],
        delete: [del_time]
      };
      if (add_time === "") { delete body.add;}
      if (del_time === "") { delete body.delete;}
      let response = await this.apiRequest(authToken, body);
      response['authToken'] = authToken;
      return response;
    } catch (e) {
      const response = {"status": 400, "message": e};
      return response;
    }
  }

  async updateFarmerBullCode(farmer_id, add_bull_code, del_bull_code) {
    try {
      const currentUser = await CognitoUserAccessor.getCurrentUser();
      const authToken = currentUser.idToken.jwtToken;
      const body = {
        command: "update_farmer_bull_code",
        farmer_id: farmer_id,
        add: [add_bull_code],
        delete: [del_bull_code]
      };
      if (add_bull_code === "") { delete body.add;}
      if (del_bull_code === "") { delete body.delete;}
      let response = await this.apiRequest(authToken, body);
      response['authToken'] = authToken;
      return response;
    }
    catch (e) {
      const response = {"status": 400, "message": e};
      return response;
    }
  }

  async updateFarmerTransfer(farmer_id, add_transfer, del_transfer) {
    try {
      const currentUser = await CognitoUserAccessor.getCurrentUser();
      const authToken = currentUser.idToken.jwtToken;
      const body = {
        command: "update_farmer_transfer",
        farmer_id: farmer_id,
        add: [add_transfer],
        delete: [del_transfer]
      };
      if (add_transfer === "") { delete body.add;}
      if (del_transfer === "") { delete body.del;}
      let response = await this.apiRequest(authToken, body);
      response['authToken'] = authToken;
      return response;
    }
    catch (e) {
      const response = {"status": 400, "message": e};
      return response;
    }
  }

  async updateFarmerInseminator(farmer_id, add_inseminator, del_inseminator) {
    try {
      const currentUser = await CognitoUserAccessor.getCurrentUser();
      const authToken = currentUser.idToken.jwtToken;
      const body = {
        command: "update_farmer_inseminator",
        farmer_id: farmer_id,
        add: [add_inseminator],
        delete: [del_inseminator]
      };
      if (add_inseminator === "") { delete body.add;}
      if (del_inseminator === "") { delete body.del;}
      let response = await this.apiRequest(authToken, body);
      response['authToken'] = authToken;
      return response;
    }
    catch (e) {
      const response = {"status": 400, "message": e};
      return response;
    }
  }

  async addFarmer(farmer_id, farmer_name, inseminator, bull_code) {
    try {
      const currentUser = await CognitoUserAccessor.getCurrentUser();
      const authToken = currentUser.idToken.jwtToken;
      const body = {
        command: "add_farmer",
        farmer_id: farmer_id,
        farmer_name: farmer_name,
        inseminator: [inseminator],
        bull_code: [bull_code]
      };
      let response = await this.apiRequest(authToken, body);
      response['authToken'] = authToken;
      return response;
    }
    catch (e) {
      const response = {"status": 400, "message": e};
      return response;
    }
  }

  async getFarmers() {
    try {
      const currentUser = await CognitoUserAccessor.getCurrentUser();
      const authToken = currentUser.idToken.jwtToken;
      const body = {
        command: "get_farmers"
      };
      let response = await this.apiRequest(authToken, body);
      response['authToken'] = authToken;
      return response;
    }
    catch (e) {
      const response = {"status": 400, "message": e};
      return response;
    }
  }

  async getFarmer(farmer_id) {
    try {
      const currentUser = await CognitoUserAccessor.getCurrentUser();
      const authToken = currentUser.idToken.jwtToken;
      const body = {
        command: "get_farmer",
        farmer_id: farmer_id
      };
      let response = await this.apiRequest(authToken, body);
      response['authToken'] = authToken;
      return response;
    }
    catch (e) {
      const response = {"status": 400, "message": e};
      return response;
    }
  }

  async updateFarmer(farmer_id, farmer_name, inseminator, bull_code, feeding_times, pregnancy_term) {
    try {
      const currentUser = await CognitoUserAccessor.getCurrentUser();
      const authToken = currentUser.idToken.jwtToken;
      const body = {
        command: "update_farmer",
        farmer_id: farmer_id,
        farmer_name: farmer_name,
        inseminator: inseminator,
        bull_code: bull_code,
        feeding_times: feeding_times,
        pregnancy_term: pregnancy_term
      };
      if (farmer_name === "") { delete body.farmer_name;}
      if (!inseminator) { delete body.inseminator;}
      if (!bull_code) { delete body.bull_code;}
      if (!feeding_times) { delete body.feeding_times;}
      // if (!pregnancy_term) { delete body.pregnancy_term;}
      let response = await this.apiRequest(authToken, body);
      response['authToken'] = authToken;
      return response;
    }
    catch (e) {
      const response = {"status": 400, "message": e};
      return response;
    }
  }

  async deleteFarmer(farmer_id) {
    try {
      const currentUser = await CognitoUserAccessor.getCurrentUser();
      const authToken = currentUser.idToken.jwtToken;
      const body = {
        command: "delete_farmer",
        farmer_id: farmer_id
      };
      let response = await this.apiRequest(authToken, body);
      response['authToken'] = authToken;
      return response;
    }
    catch (e) {
      const response = {"status": 400, "message": e};
      return response;
    }
  }

  async getUserSp3(
      barn_id, cow_start_key, cow_sort, cow_sort_forward, cow_pregnancy_status,
      cow_status, cow_sex, cow_in_barn, cow_number, reports_dates
    ) {
    try {
      const currentUser = await CognitoUserAccessor.getCurrentUser();
      const authToken = currentUser.idToken.jwtToken;
      const body = {
        command: "get_user_sp3",
        barn_id: barn_id,
        cow_start_key: cow_start_key,
        cow_sort: cow_sort,
        cow_sort_forward: cow_sort_forward,
        cow_pregnancy_status: cow_pregnancy_status,
        cow_status: cow_status,
        cow_sex: cow_sex,
        cow_in_barn: cow_in_barn,
        cow_number: cow_number,
        reports_dates: reports_dates
      };
      if (barn_id === "") { delete body.barn_id;}
      if (!cow_start_key) { delete body.cow_start_key;}
      if (!cow_sort) { delete body.cow_sort;}
      if (!cow_sort_forward) { delete body.cow_sort_forward;}
      if (!cow_pregnancy_status) { delete body.cow_pregnancy_status;}
      if (!cow_status) { delete body.cow_status;}
      if (!cow_sex) { delete body.cow_sex;}
      if (!cow_in_barn) { delete body.cow_in_barn;}
      if (cow_number === "") { delete body.cow_number; }
      if (!reports_dates) { delete body.reports_dates; }
      let response = await this.apiRequest(authToken, body);
      response['authToken'] = authToken;
      return response;
    }
    catch (e) {
      const response = {"status": 400, "message": e};
      return response;
    }
  }

  // async getUserSp2(
  //     barn_id, cow_start_key, cow_sort, cow_sort_forward, cow_pregnancy_status,
  //     cow_status, cow_sex, cow_in_barn, cow_number
  //   ) {
  //   try {
  //     const currentUser = await CognitoUserAccessor.getCurrentUser();
  //     const authToken = currentUser.idToken.jwtToken;
  //     const body = {
  //       command: "get_user_sp2",
  //       barn_id: barn_id,
  //       cow_start_key: cow_start_key,
  //       cow_sort: cow_sort,
  //       cow_sort_forward: cow_sort_forward,
  //       cow_pregnancy_status: cow_pregnancy_status,
  //       cow_status: cow_status,
  //       cow_sex: cow_sex,
  //       cow_in_barn: cow_in_barn,
  //       cow_number: cow_number
  //     };
  //     if (barn_id === "") { delete body.barn_id;}
  //     if (!cow_start_key) { delete body.cow_start_key;}
  //     if (!cow_sort) { delete body.cow_sort;}
  //     if (!cow_sort_forward) { delete body.cow_sort_forward;}
  //     if (!cow_pregnancy_status) { delete body.cow_pregnancy_status;}
  //     if (!cow_status) { delete body.cow_status;}
  //     if (!cow_sex) { delete body.cow_sex;}
  //     if (!cow_in_barn) { delete body.cow_in_barn;}
  //     if (cow_number === "") { delete body.cow_number;}
  //     let response = await this.apiRequest(authToken, body);
  //     response['authToken'] = authToken;
  //     return response;
  //   }
  //   catch (e) {
  //     const response = {"status": 400, "message": e};
  //     return response;
  //   }
  // }

  // async getUserSp() {
  //   try {
  //     const currentUser = await CognitoUserAccessor.getCurrentUser();
  //     const authToken = currentUser.idToken.jwtToken;
  //     const body = {
  //       command: "get_user_sp"
  //     };
  //     let response = await this.apiRequest(authToken, body);
  //     response['authToken'] = authToken;
  //     return response;
  //   }
  //   catch (e) {
  //     const response = {"status": 400, "message": e};
  //     return response;
  //   }
  // }

  async addUser(enc_data, iv, created_at) {
    try {
      const currentUser = await CognitoUserAccessor.getCurrentUser();
      const authToken = currentUser.idToken.jwtToken;
      const body = {
        command: "add_user",
        encrypt: { data: enc_data, iv: iv, created_at}
      };
      let response = await this.apiRequest(authToken, body);
      response['authToken'] = authToken;
      return response;
    }
    catch (e) {
      const response = {"status": e.response.status, "message": e};
      return response;
    }
  }

  async updateLoginUser(user_name, alert_notification, alert_supression_time) {
    try {
      const currentUser = await CognitoUserAccessor.getCurrentUser();
      const authToken = currentUser.idToken.jwtToken;
      const body = {
        command: "update_login_user",
        user_name: user_name,
        alert_notification: alert_notification,
        alert_supression_time: alert_supression_time
      };
      let response = await this.apiRequest(authToken, body);
      response['authToken'] = authToken;
      return response;
    } catch (e) {
      const response = {"status": 400, "message": e};
      return response;
    }
  }

  async getUsers(farmer_id) {
    try {
      const currentUser = await CognitoUserAccessor.getCurrentUser();
      const authToken = currentUser.idToken.jwtToken;
      const body = {
        command: "get_users",
        farmer_id: farmer_id
      };
      let response = await this.apiRequest(authToken, body);
      response['authToken'] = authToken;
      return response;
    }
    catch (e) {
      const response = {"status": 400, "message": e};
      return response;
    }
  }

  async updateUser(farmer_id, user_id, user_name, alert_notification, alert_supression_time, sns_arn, last_alert, user_type) {
    try {
      const currentUser = await CognitoUserAccessor.getCurrentUser();
      const authToken = currentUser.idToken.jwtToken;
      const body = {
        command: "update_user",
        farmer_id: farmer_id,
        user_id: user_id,
        user_name: user_name,
        alert_notification:alert_notification,
        alert_supression_time: alert_supression_time,
        sns_arn: [sns_arn],
        last_alert: last_alert,
        user_type: user_type
      };
      if (alert_notification === "") { delete body.alert_notification;}
      if (alert_supression_time === "") { delete body.alert_supression_time;}
      if (sns_arn === "") { delete body.sns_arn;}
      if (last_alert === "") { delete body.last_alert;}
      let response = await this.apiRequest(authToken, body);
      response['authToken'] = authToken;
      return response;
    } catch (e) {
        const response = {"status": 400, "message": e};
        return response;
    }
  }

  async deleteUser(farmer_id, user_id) {
    try {
      const currentUser = await CognitoUserAccessor.getCurrentUser();
      const authToken = currentUser.idToken.jwtToken;
      const body = {
        command: "delete_user",
        farmer_id: farmer_id, 
        user_id: user_id
      };
      let response = await this.apiRequest(authToken, body);
      response['authToken'] = authToken;
      return response;
    }
    catch (e) {
      const response = {"status": 400, "message": e};
      return response;
    }
  }

  async addBull(farmer_id, bull_name, bull_number, bull_breed, pedigree) {
    try {
      const currentUser = await CognitoUserAccessor.getCurrentUser();
      const authToken = currentUser.idToken.jwtToken;
      const body = {
        command: "add_bull",
        farmer_id: farmer_id,
        bull_name: bull_name,
        bull_number: bull_number,
        bull_breed: bull_breed,
        pedigree: pedigree
      };
      let response = await this.apiRequest(authToken, body);
      response['authToken'] = authToken;
      return response;
    } catch (e) {
      const response = {"status": 400, "message": e};
      return response;
    }
  }

  async getBulls(farmer_id) {
    try {
      const currentUser = await CognitoUserAccessor.getCurrentUser();
      const authToken = currentUser.idToken.jwtToken;
      const body = {
        command: "get_bulls",
        farmer_id: farmer_id
      };
      let response = await this.apiRequest(authToken, body);
      response['authToken'] = authToken;
      return response;
    } catch (e) {
      const response = {"status": 400, "message": e};
      return response;
    }
  }

  async getBull(bull_id) {
    try {
      const currentUser = await CognitoUserAccessor.getCurrentUser();
      const authToken = currentUser.idToken.jwtToken;
      const body = {
          command: "get_bull",
          bull_id: bull_id
      };
      let response = await this.apiRequest(authToken, body);
      response['authToken'] = authToken;
      return response;
    } catch (e) {
      const response = {"status": 400, "message": e};
      return response;
    }
  }

  async updateBull(bull_id, bull_name, bull_number, bull_breed, pedigree) {
    try {
        const currentUser = await CognitoUserAccessor.getCurrentUser();
        const authToken = currentUser.idToken.jwtToken;
        const body = {
            command: "update_bull",
            bull_id: bull_id,
            bull_name: bull_name,
            bull_number: bull_number,
            bull_breed: bull_breed,
            pedigree: pedigree,
        };
        let response = await this.apiRequest(authToken, body);
        response['authToken'] = authToken;
        return response;
    }
    catch (e) {
        const response = {"status": 400, "message": e};
        return response;
    }
  }

  async deleteBull(bull_id) {
    try {
        const currentUser = await CognitoUserAccessor.getCurrentUser();
        const authToken = currentUser.idToken.jwtToken;
        const body = {
            command: "delete_bull",
            bull_id: bull_id
        };
        let response = await this.apiRequest(authToken, body);
        response['authToken'] = authToken;
        return response;
    }
    catch (e) {
        const response = {"status": 400, "message": e};
        return response;
    }
  }

  async addEgg(farmer_id, fa_name, fa_number, fa_breed, fa_pedigree, mo_name, mo_number, mo_breed, mo_pedigree) {
    try {
        const currentUser = await CognitoUserAccessor.getCurrentUser();
        const authToken = currentUser.idToken.jwtToken;
        const body = {
          command: "add_egg",
          farmer_id: farmer_id,
          fa_name: fa_name,
          fa_number: fa_number,
          fa_breed: fa_breed,
          fa_pedigree: fa_pedigree,
          mo_name: mo_name,
          mo_number: mo_number,
          mo_breed: mo_breed,
          mo_pedigree: mo_pedigree
        };
        let response = await this.apiRequest(authToken, body);
        response['authToken'] = authToken;
        return response;
    }
    catch (e) {
        const response = {"status": 400, "message": e};
        return response;
    }
  }

  async getEggs(farmer_id) {
    try {
        const currentUser = await CognitoUserAccessor.getCurrentUser();
        const authToken = currentUser.idToken.jwtToken;
        const body = {
            command: "get_eggs",
            farmer_id: farmer_id
        };
        let response = await this.apiRequest(authToken, body);
        response['authToken'] = authToken;
        return response;
    }
    catch (e) {
        const response = {"status": 400, "message": e};
        return response;
    }
  }

  async getEgg(egg_id) {
    try {
        const currentUser = await CognitoUserAccessor.getCurrentUser();
        const authToken = currentUser.idToken.jwtToken;
        const body = {
            command: "get_egg",
            egg_id: egg_id
        };
        let response = await this.apiRequest(authToken, body);
        response['authToken'] = authToken;
        return response;
    }
    catch (e) {
        const response = {"status": 400, "message": e};
        return response;
    }
  }

  async updateEgg(egg_id, fa_name, fa_number, fa_breed, fa_pedigree, mo_name, mo_number, mo_breed, mo_pedigree) {
    try {
        const currentUser = await CognitoUserAccessor.getCurrentUser();
        const authToken = currentUser.idToken.jwtToken;
        const body = {
          command: "update_egg",
          egg_id: egg_id,
          fa_name: fa_name,
          fa_number: fa_number,
          fa_breed: fa_breed,
          fa_pedigree: fa_pedigree,
          mo_name: mo_name,
          mo_number: mo_number,
          mo_breed: mo_breed,
          mo_pedigree: mo_pedigree
        };
        let response = await this.apiRequest(authToken, body);
        response['authToken'] = authToken;
        return response;
    }
    catch (e) {
        const response = {"status": 400, "message": e};
        return response;
    }
  }

  async deleteEgg(egg_id) {
    try {
        const currentUser = await CognitoUserAccessor.getCurrentUser();
        const authToken = currentUser.idToken.jwtToken;
        const body = {
            command: "delete_egg",
            egg_id: egg_id
        };
        let response = await this.apiRequest(authToken, body);
        response['authToken'] = authToken;
        return response;
    }
    catch (e) {
        const response = {"status": 400, "message": e};
        return response;
    }
  }

  async addCow(farmer_id, cow_name, cow_sex, cow_birth, cow_number, cow_breed, cow_status, cow_pregnancy_status, pedigree) {
    try {
        const currentUser = await CognitoUserAccessor.getCurrentUser();
        const authToken = currentUser.idToken.jwtToken;
        const body = {
          command: "add_cow",
          farmer_id: farmer_id,
          cow_name: cow_name,
          cow_sex: cow_sex,
          cow_birth: cow_birth,
          cow_number: cow_number,
          cow_breed: cow_breed,
          cow_status: cow_status,
          cow_pregnancy_status: cow_pregnancy_status,
          pedigree: pedigree,
          face_image_date: 0
        };
        let response = await this.apiRequest(authToken, body);
        response['authToken'] = authToken;
        return response;
    }
    catch (e) {
        const response = {"status": 400, "message": e};
        return response;
    }
  }

  async addCowBirth(
    farmer_id, cow_name, cow_sex, cow_birth, cow_number, cow_breed, cow_status, cow_pregnancy_status, pedigree,
    estrus_on, inseminate, pregnancy,  birth_reserve_date, birth, calf_id, is_lick_amnion) {
    try {
        const currentUser = await CognitoUserAccessor.getCurrentUser();
        const authToken = currentUser.idToken.jwtToken;
        const body = {
          command: "add_cow_birth",
          farmer_id: farmer_id,
          cow_name: cow_name,
          cow_sex: cow_sex,
          cow_birth: cow_birth,
          cow_number: cow_number,
          cow_breed: cow_breed,
          cow_status: cow_status,
          cow_pregnancy_status: cow_pregnancy_status,
          pedigree: pedigree,
          face_image_date: "",
          birth: {
            estrus_on: estrus_on,
            inseminate: inseminate,
            pregnancy: pregnancy,
            birth_reserve_date: birth_reserve_date,
            birth: birth,
            calf_id: calf_id,
            is_lick_amnion: is_lick_amnion
          }
        };
        if (birth === "") { delete body.birth.birth; }
        let response = await this.apiRequest(authToken, body);
        response['authToken'] = authToken;
        return response;
    }
    catch (e) {
        const response = {"status": 400, "message": e};
        return response;
    }
  }

async getSortCows(
    farmer_id, start_key, cow_sort, cow_sort_forward, cow_pregnancy_status,
    cow_status, cow_status_not_exists, cow_sex, cow_sex_not_exists,
    cow_breed, cow_breed_not_exists, cow_in_barn, cow_search_text, is_number
  ) {
  try {
    const currentUser = await CognitoUserAccessor.getCurrentUser();
    const authToken = currentUser.idToken.jwtToken;
    const body = {
      command: "get_sort_cows",
      farmer_id: farmer_id,
      start_key: start_key,
      cow_sort: cow_sort,
      cow_sort_forward: cow_sort_forward,
      cow_pregnancy_status: cow_pregnancy_status,
      cow_status: cow_status,
      cow_status_not_exists: cow_status_not_exists,
      cow_sex: cow_sex,
      cow_sex_not_exists: cow_sex_not_exists,
      cow_breed: cow_breed,
      cow_breed_not_exists: cow_breed_not_exists,
      cow_in_barn: cow_in_barn,
      cow_number: cow_search_text,
      cow_name: cow_search_text
    };
    if (!start_key || start_key == {}) { delete body.start_key;}
    if (cow_sort === undefined) { delete body.cow_sort;}
    if (cow_sort_forward === undefined) { delete body.cow_sort_forward;}
    // if (!cow_pregnancy_status || cow_pregnancy_status.length == 0) { delete body.cow_pregnancy_status;}
    if (!cow_status || cow_status.length == 0) { delete body.cow_status;}
    if (!cow_pregnancy_status) { delete body.cow_pregnancy_status;}
    // if (!cow_status) { delete body.cow_status;}
    if (!cow_sex || cow_sex.length == 0) { delete body.cow_sex;}
    if (!cow_breed || cow_breed.length == 0) { delete body.cow_breed;}
    if (cow_in_barn === undefined) { delete body.cow_in_barn; }
    if (is_number) {
      delete body.cow_name;
      if (cow_search_text === "") {
        delete body.cow_number;
      }
    } else {
      delete body.cow_number;
      if (cow_search_text === "") {
        delete body.cow_name;
      }
    }
    let response = await this.apiRequest(authToken, body);
    response['authToken'] = authToken;
    return response;
  }
  catch (e) {
    const response = {"status": 400, "message": e};
    return response;
  }
}

async getCows(farmer_id) {
    try {
        const currentUser = await CognitoUserAccessor.getCurrentUser();
        const authToken = currentUser.idToken.jwtToken;
        const body = {
            command: "get_cows",
            farmer_id: farmer_id
        };
        let response = await this.apiRequest(authToken, body);
        response['authToken'] = authToken;
        return response;
    }
    catch (e) {
        const response = {"status": 400, "message": e};
        return response;
    }
  }

  async updateCow(cow_id, cow_name, cow_sex, cow_birth, cow_number, cow_breed, cow_status, cow_pregnancy_status, pedigree) {
    try {
        const currentUser = await CognitoUserAccessor.getCurrentUser();
        const authToken = currentUser.idToken.jwtToken;
        const body = {
            command: "update_cow",
            cow_id: cow_id,
            cow_name: cow_name,
            cow_sex: cow_sex,
            cow_birth: cow_birth,
            cow_number: cow_number,
            cow_breed: cow_breed,
            cow_status: cow_status,
            cow_pregnancy_status: cow_pregnancy_status,
            pedigree: pedigree,
        };
        let response = await this.apiRequest(authToken, body);
        response['authToken'] = authToken;
        return response;
    }
    catch (e) {
        const response = {"status": 400, "message": e};
        return response;
    }
  }

  async deleteCow(cow_id) {
    try {
        const currentUser = await CognitoUserAccessor.getCurrentUser();
        const authToken = currentUser.idToken.jwtToken;
        const body = {
            command: "delete_cow",
            cow_id: cow_id
        };
        let response = await this.apiRequest(authToken, body);
        response['authToken'] = authToken;
        return response;
    }
    catch (e) {
        const response = {"status": 400, "message": e};
        return response;
    }
  }

  async addBirth(cow_id, estrus_on, inseminate, pregnancy,  birth_reserve_date, birth, calf_id, is_lick_amnion) {
    try {
        const currentUser = await CognitoUserAccessor.getCurrentUser();
        const authToken = currentUser.idToken.jwtToken;
        const body = {
            command: "add_birth",
            cow_id: cow_id,
            estrus_on: estrus_on,
            inseminate: inseminate,
            pregnancy: pregnancy,
            birth_reserve_date: birth_reserve_date,
            birth: birth,
            calf_id: calf_id,
            is_lick_amnion: is_lick_amnion
        };
        if (birth === "") { delete body.birth; }
        let response = await this.apiRequest(authToken, body);
        response['authToken'] = authToken;
        return response;
    }
    catch (e) {
        const response = {"status": 400, "message": e};
        return response;
    }
  }

  async updateBirth(birth_id, estrus_on, inseminate, pregnancy, birth_reserve_date, birth, calf_id, is_lick_amnion) {
    try {
        const currentUser = await CognitoUserAccessor.getCurrentUser();
        const authToken = currentUser.idToken.jwtToken;
        const body = {
            command: "update_birth",
            birth_id: birth_id,
            estrus_on: estrus_on,
            inseminate: inseminate,
            pregnancy: pregnancy,
            birth_reserve_date: birth_reserve_date,
            birth: birth,
            calf_id: calf_id,
            is_lick_amnion: is_lick_amnion
        };
        if (birth === "") { delete body.birth; }
        let response = await this.apiRequest(authToken, body);
        response['authToken'] = authToken;
        return response;
    }
    catch (e) {
        const response = {"status": 400, "message": e};
        return response;
    }
  }

  async getBirths(cow_id) {
    try {
        const currentUser = await CognitoUserAccessor.getCurrentUser();
        const authToken = currentUser.idToken.jwtToken;
        const body = {
            command: "get_births",
            cow_id: cow_id
        };
        let response = await this.apiRequest(authToken, body);
        response['authToken'] = authToken;
        return response;
    }
    catch (e) {
        const response = {"status": 400, "message": e};
        return response;
    }
  }

  async deleteBirth(birth_id) {
    try {
        const currentUser = await CognitoUserAccessor.getCurrentUser();
        const authToken = currentUser.idToken.jwtToken;
        const body = {
            command: "delete_birth",
            birth_id: birth_id
        };
        let response = await this.apiRequest(authToken, body);
        response['authToken'] = authToken;
        return response;
    }
    catch (e) {
        const response = {"status": 400, "message": e};
        return response;
    }
  }

  async addBarn(barn_name, cow_id, cameras) {
    try {
        const currentUser = await CognitoUserAccessor.getCurrentUser();
        const authToken = currentUser.idToken.jwtToken;
        const body = {
            command: "add_barn",
            barn_name: barn_name,
            cow_id: [cow_id],
            cameras: [cameras]
        };
        let response = await this.apiRequest(authToken, body);
        response['authToken'] = authToken;
        return response;
    }
    catch (e) {
        const response = {"status": 400, "message": e};
        return response;
    }
  }

  async getBarns(farmer_id) {
    try {
        const currentUser = await CognitoUserAccessor.getCurrentUser();
        const authToken = currentUser.idToken.jwtToken;
        const body = {
            command: "get_barns",
            farmer_id: farmer_id
        };
        let response = await this.apiRequest(authToken, body);
        response['authToken'] = authToken;
        return response;
    }
    catch (e) {
        const response = {"status": 400, "message": e};
        return response;
    }
  }

  async getCowsInBarn(barn_id) {
    try {
        const currentUser = await CognitoUserAccessor.getCurrentUser();
        const authToken = currentUser.idToken.jwtToken;
        const body = {
            command: "get_cows_in_barn",
            barn_id: barn_id
        };
        let response = await this.apiRequest(authToken, body);
        response['authToken'] = authToken;
        return response;
    }
    catch (e) {
        const response = {"status": 400, "message": e};
        return response;
    }
  }

  async updateCowsInBarn(barn_id, add_cow_id, del_cow_id) {
    try {
        const currentUser = await CognitoUserAccessor.getCurrentUser();
        const authToken = currentUser.idToken.jwtToken;
        const body = {
            command: "update_cows_in_barn",
            barn_id: barn_id,
            add: [add_cow_id],
            delete: [del_cow_id]
        };
        if (add_cow_id ==="")  { delete body.add;}
        if (del_cow_id ==="")  { delete body.delete;}
        let response = await this.apiRequest(authToken, body);
        response['authToken'] = authToken;
        return response;
    }
    catch (e) {
        const response = {"status": 400, "message": e};
        return response;
    }
  }

  async updateBarn(barn_id, barn_name, cow_id) {
    try {
        const currentUser = await CognitoUserAccessor.getCurrentUser();
        const authToken = currentUser.idToken.jwtToken;
        const body = {
            command: "update_barn",
            barn_id: barn_id,
            barn_name: barn_name,
            cow_id: cow_id
        };
        let response = await this.apiRequest(authToken, body);
        response['authToken'] = authToken;
        return response;
    }
    catch (e) {
        const response = {"status": 400, "message": e};
        return response;
    }
  }

  async deleteBarn(barn_id) {
    try {
        const currentUser = await CognitoUserAccessor.getCurrentUser();
        const authToken = currentUser.idToken.jwtToken;
        const body = {
            command: "delete_barn",
            barn_id: barn_id
        };
        let response = await this.apiRequest(authToken, body);
        response['authToken'] = authToken;
        return response;
    }
    catch (e) {
        const response = {"status": 400, "message": e};
        return response;
    }
  }

  async getCowAlertsInBarn(barn_id) {
    try {
        const currentUser = await CognitoUserAccessor.getCurrentUser();
        const authToken = currentUser.idToken.jwtToken;
        const body = {
            command: "get_cow_alerts_in_barn",
            barn_id: barn_id
        };
        let response = await this.apiRequest(authToken, body);
        response['authToken'] = authToken;
        return response;
    }
    catch (e) {
        const response = {"status": 400, "message": e};
        return response;
    }
  }

  async getAlerts(barn_id, start_key, limit) {
    try {
        const currentUser = await CognitoUserAccessor.getCurrentUser();
        const authToken = currentUser.idToken.jwtToken;
        const body = {
            command: "get_alerts",
            barn_id: barn_id,
            start_key: start_key,
            limit: limit
        };
        let response = await this.apiRequest(authToken, body);
        response['authToken'] = authToken;
        return response;
    }
    catch (e) {
        const response = {"status": 400, "message": e};
        return response;
    }
  }

  async getCalfAlerts(cow_id) {
    try {
        const currentUser = await CognitoUserAccessor.getCurrentUser();
        const authToken = currentUser.idToken.jwtToken;
        const body = {
            command: "get_calf_alerts",
            cow_id: cow_id
        };
        let response = await this.apiRequest(authToken, body);
        response['authToken'] = authToken;
        return response;
    }
    catch (e) {
        const response = {"status": 400, "message": e};
        return response;
    }
  }

  async getBirthAlerts(birth_id) {
    try {
        const currentUser = await CognitoUserAccessor.getCurrentUser();
        const authToken = currentUser.idToken.jwtToken;
        const body = {
            command: "get_birth_alerts",
            birth_id: birth_id
        };
        let response = await this.apiRequest(authToken, body);
        response['authToken'] = authToken;
        return response;
    }
    catch (e) {
        const response = {"status": 400, "message": e};
        return response;
    }
  }

  async lockAlert(barn_id, date_times, is_lock) {
    try {
        const currentUser = await CognitoUserAccessor.getCurrentUser();
        const authToken = currentUser.idToken.jwtToken;
        const body = {
            command: "lock_alert",
            barn_id: barn_id,
            date_times: date_times,
            is_lock: is_lock
        };
        let response = await this.apiRequest(authToken, body);
        response['authToken'] = authToken;
        return response;
    }
    catch (e) {
        const response = {"status": 400, "message": e};
        return response;
    }
  }

  async deleteAlert(barn_id, date_times) {
    try {
        const currentUser = await CognitoUserAccessor.getCurrentUser();
        const authToken = currentUser.idToken.jwtToken;
        const body = {
            command: "delete_alert",
            barn_id: barn_id,
            date_times: date_times
        };
        let response = await this.apiRequest(authToken, body);
        response['authToken'] = authToken;
        return response;
    }
    catch (e) {
        const response = {"status": 400, "message": e};
        return response;
    }
  }

  async wrongDetectAlert(barn_id, date_times, is_wrong_detect) {
    try {
        const currentUser = await CognitoUserAccessor.getCurrentUser();
        const authToken = currentUser.idToken.jwtToken;
        const body = {
            command: "wrong_detect_alert",
            barn_id: barn_id,
            date_times: date_times,
            is_wrong_detect: is_wrong_detect
        };
        let response = await this.apiRequest(authToken, body);
        response['authToken'] = authToken;
        return response;
    }
    catch (e) {
        const response = {"status": 400, "message": e};
        return response;
    }
  }

  async actAlert(barn_id, date_times, is_action) {
    try {
        const currentUser = await CognitoUserAccessor.getCurrentUser();
        const authToken = currentUser.idToken.jwtToken;
        const body = {
            command: "act_alert",
            barn_id: barn_id,
            date_times: date_times,
            is_action: is_action
        };
        let response = await this.apiRequest(authToken, body);
        response['authToken'] = authToken;
        return response;
    }
    catch (e) {
        const response = {"status": 400, "message": e};
        return response;
    }
  }

  async readAlert(barn_id, date_times) {
    try {
        const currentUser = await CognitoUserAccessor.getCurrentUser();
        const authToken = currentUser.idToken.jwtToken;
        const body = {
            command: "read_alert",
            barn_id: barn_id,
            date_times: date_times
        };
        let response = await this.apiRequest(authToken, body);
        response['authToken'] = authToken;
        return response;
    }
    catch (e) {
        const response = {"status": 400, "message": e};
        return response;
    }
  }

  async getReports(barn_id, begin_date_time, end_date_time) {
    try {
        const currentUser = await CognitoUserAccessor.getCurrentUser();
        const authToken = currentUser.idToken.jwtToken;
        const body = {
            command: "get_reports",
            barn_id: barn_id,
            begin_date_time: begin_date_time,
            end_date_time: end_date_time
        };
        let response = await this.apiRequest(authToken, body);
        response['authToken'] = authToken;
        return response;
    }
    catch (e) {
        const response = {"status": 400, "message": e};
        return response;
    }
  }
  
  async getCowReportsInBarn(barn_id) {
    try {
        const currentUser = await CognitoUserAccessor.getCurrentUser();
        const authToken = currentUser.idToken.jwtToken;
        const body = {
            command: "get_cow_reports_in_barn",
            barn_id: barn_id
        };
        let response = await this.apiRequest(authToken, body);
        response['authToken'] = authToken;
        return response;
    }
    catch (e) {
        const response = {"status": 400, "message": e};
        return response;
    }
  }
  
  async getNvrs(farmer_id) {
    try {
        const currentUser = await CognitoUserAccessor.getCurrentUser();
        const authToken = currentUser.idToken.jwtToken;
        const body = {
            command: "get_nvrs",
            farmer_id: farmer_id
        };
        let response = await this.apiRequest(authToken, body);
        response['authToken'] = authToken;
        return response;
    }
    catch (e) {
        const response = {"status": 400, "message": e};
        return response;
    }
  }

  async getRecs(farmer_id) {
    try {
        const currentUser = await CognitoUserAccessor.getCurrentUser();
        const authToken = currentUser.idToken.jwtToken;
        const body = {
            command: "get_recs",
            farmer_id: farmer_id
        };
        let response = await this.apiRequest(authToken, body);
        response['authToken'] = authToken;
        return response;
    }
    catch (e) {
        const response = {"status": 400, "message": e};
        return response;
    }
  }

}

export default new WebAPI();
